import { IOnboarding } from '@/types/components/onboarding';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ONBOARDING_CUTOFF, WeekdayEnum } from '@/constants/enum';

const initialState: IOnboarding = {
  step: 0,
  isEnablePickup: false,
  isEnableDelivery: false,
  isEnableShipping: false,
  position: '',
  weeklyWorkingDays: [
    {
      day: WeekdayEnum.SUNDAY,
      isEnable: true,
    },
    {
      day: WeekdayEnum.MONDAY,
      isEnable: true,
    },
    {
      day: WeekdayEnum.TUESDAY,
      isEnable: true,
    },
    {
      day: WeekdayEnum.WEDNESDAY,
      isEnable: true,
    },
    {
      day: WeekdayEnum.THURSDAY,
      isEnable: true,
    },
    {
      day: WeekdayEnum.FRIDAY,
      isEnable: true,
    },
    {
      day: WeekdayEnum.SATURDAY,
      isEnable: true,
    },
  ],
  preparationTime: 0,
  isEnableCutOffTime: false,
  cutoffTime: '18:00',
  cutOffPreparationTime: 1,
  blackoutDates: null,
  isOpenPreview: false,
  calendarTab: ONBOARDING_CUTOFF.BEFORE,
  theme: '',
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    handleSaveOnboardingSettings: (state, action: PayloadAction<Partial<IOnboarding>>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const onboardingSettingSelector = createSelector(
  (state: RootState) => state.onboarding,
  (state) => state,
);

export const { handleSaveOnboardingSettings } = onboardingSlice.actions;

export default onboardingSlice;
